module.exports = __webpack_public_path__ + "static/media/arts_4.6375c53c.jpg";